export default __webpack_public_path__ + "static/media/sharktank.1de5c3a9.jpeg";